
  import TextAndImage from '@/components/elements/TextAndImage';
  import FaqPanel from '@/components/elements/FaqPanel';
  import ArticleCta from '@/components/elements/ArticleCta';
  import TextAndYoutubeVideo from '@/components/elements/TextAndYoutubeVideo.vue';
  export default {
    components: {
      TextAndImage,
      FaqPanel,
      ArticleCta,
      TextAndYoutubeVideo,
    },
    props: {
      article: {
        type: Object,
        required: true,
      },
    },
    methods: {
      checkVisibility(content) {
        return (
          (content.visibility_type === 'just_logged_out' &&
            !this.$auth.loggedIn) ||
          (content.visibility_type === 'just_logged_in' &&
            this.$auth.loggedIn) ||
          content.visibility_type === 'all_users' ||
          content.visibility_type === null
        );
      },
    },
    jsonld() {
      const faqQuestions = [];
      for (const key in this.article.contents) {
        if (key === 'hydra:view') {
          continue;
        }

        const element = this.article.contents[key];
        if (element.question) {
          faqQuestions.push({
            '@type': 'Question',
            name: element.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: element.answer,
            },
          });
        }
      }

      if (faqQuestions.length === 0) {
        return null;
      }

      return {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqQuestions,
      };
    },
  };
